import * as React from 'react';
import { t } from '@moovly/i18n';
import { Table, TableBody, TableCol, TableHeader, TableLoader, TableRow } from '../../../../components/Table';
import { BasicProjectInfo, Project } from '@moovly/clients/lib/resources/projects/projects.interfaces';
import { formatDate } from '../../../../utils/date';
import { Button, IconChevronDown, Select } from '@moovly/ui';
import './ProjectsTable.scss';
import { useDispatch } from 'react-redux';
import { updateMembership } from '../../../../store/members.store';
import { getSupportedRoles } from '../../config/roles';
import { updateProject } from '../../../../store/projects.store';

interface ProjectsTableProps {
  projects: Project[];
  count: number;
  loading: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
  allGroupsWithAccess: { value: string; label: string }[];
}

const ProjectsTable: React.FC<ProjectsTableProps> = ({ projects, count, loading, hasMore, onLoadMore, allGroupsWithAccess }) => {
  //console.log(projects);
  const dispatch = useDispatch<any>();
  const handleWorkspaceChangeForProject = React.useCallback(
    ({ value, projectId }: { value: string, projectId: string }) => {
      dispatch(updateProject({ groupId: value, projectId: projectId }));
    },
    [dispatch]
  );

  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            <TableCol>{t('projects.table.headers.thumb')}</TableCol>
            <TableCol>{t('projects.table.headers.title')}</TableCol>
            <TableCol>{t('projects.table.headers.updated_at')}</TableCol>
            <TableCol>{t('user.organizations.addUser.placeholder')}</TableCol>
          </TableRow>
        </TableHeader>
        <TableBody>
          {projects.map((project) => (
            <TableRow key={`projectstable-item-${project.id}`}>
              <TableCol>
                <div className="ProjectsTable--ThumbnailContainer">
                  <img src={project.thumb} alt="thumbnail" width="130px" />
                </div>
              </TableCol>
              <TableCol>{project.label}</TableCol>
              <TableCol>{formatDate(project.updated_at)}</TableCol>
              <TableCol>
                <Select
                  name="SelectWorkspaceForProject"
                  id="WorkspaceSelect"
                  onChange={(selectedItem) => handleWorkspaceChangeForProject({value: selectedItem.value, projectId: project.id})}
                  options={allGroupsWithAccess}
                  defaultValue={allGroupsWithAccess.find((group) => group.value === project.workspace_id)}
                />
              </TableCol>
            </TableRow>
          ))}
          {loading && <TableLoader rows={3} columnns={3} />}
        </TableBody>
      </Table>
      {hasMore && <Button icon={IconChevronDown} onClick={onLoadMore} label={t('actions.loadMore')} className="mb-5" />}
    </>
  );
};
export default ProjectsTable;
